import IconButton from 'components/common/IconButton';
import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ButtonShareProperty = ({
  funcion,
  data,
  disabled,
  text,
  className,
  justify = 'center',
  tooltipPosition
}) => {
  return text ? (
    <Button
      className={
        className + ' d-flex align-items-center justify-content-center'
      }
      variant={!disabled ? 'primary' : 'light'}
      size="sm"
      disabled={disabled}
      onClick={data ? () => funcion(data) : funcion}
      type="submit"
      style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
    >
      <div
        className={`w-100 d-flex align-items-center justify-content-${justify} gap-1`}
      >
        <FontAwesomeIcon icon="share" style={{ marginRight: 5 }} />
        <span style={{ marginRight: 10 }}>{text}</span>
      </div>
    </Button>
  ) : (
    <OverlayTrigger
      placement={tooltipPosition || 'bottom'}
      overlay={<Tooltip>Compartir</Tooltip>}
    >
      <span>
        <IconButton
          buttonSize="sm"
          style={{ width: 30 }}
          icon="share"
          onClick={
            !disabled ? (data ? () => funcion(data) : funcion) : () => {}
          }
          disabled={disabled}
          variant="light"
          className="px-2"
        />
      </span>
    </OverlayTrigger>
  );
};

ButtonShareProperty.propTypes = {
  funcion: PropTypes.func.isRequired,
  data: PropTypes.any,
  disabled: PropTypes.bool,
  text: PropTypes.string,
  className: PropTypes.string,
  justify: PropTypes.oneOf(['start', 'center', 'end']),
  tooltipPosition: PropTypes.oneOf(['top', 'right', 'bottom', 'left'])
};

export default ButtonShareProperty;
